<template>
  <Select
    :label="label"
    :value="value"
    :disabled="disable"
    :id="id"
    :startVerific="startVerific"
    :filterable="filterable"
    :errmsg="errmsg"
    :options="OPTIONS"
    :placeholder="placeholder"
    :isError="isError"
    :isVerific="isVerific"
    @input="handleInput"
  />
</template>
<script>
import Select from '../../Select/select';
import OPTIONS from './options';
export default {
  name: 'GenderSelect',
  components: {
    Select
  },
  /**
   * @prop {String} label 组件标签
   * @prop {String} value 组件数据
   * @prop {Array} options 下拉框数据
   * @prop {Boolena} disable 是否禁用 默认false
   * @prop {Boolena} startVerific 是否开启验证
   * @prop {Boolean} error 是否错误 默认false
   */
  props: {
    label: {
      type: String,
      default: '测试呀'
    },
    // 默认值
    value: {
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    errmsg: {
      type: String,
      default: '请选择'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isError: {
      type: Boolean,
      default: false
    },
    isVerific: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    OPTIONS() {
      return OPTIONS;
    }
  },
  methods: {
    handleInput: function(value) {
      this.$emit('input', value);
    }
  }
};
</script>
